var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImg = function SvgImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#99A3AC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.726.018H.253C.113.018 0 .142 0 .294v13.174c0 .152.113.275.253.275h15.473c.14 0 .253-.123.253-.275V.294c0-.152-.114-.276-.253-.276M14.46 11.545 10.978 7.62a.1.1 0 0 0-.143-.007L8.42 9.927 5.333 5.788a.1.1 0 0 0-.163.004l-3.651 5.335V1.672h12.94v9.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.636 5.655c.685 0 1.242-.606 1.242-1.353S11.32 2.95 10.636 2.95c-.686 0-1.242.606-1.242 1.353s.556 1.353 1.242 1.353z"
  }))));
};
export default SvgImg;